import { render, staticRenderFns } from "./Association.vue?vue&type=template&id=833e9524&scoped=true"
import script from "./Association.vue?vue&type=script&lang=ts"
export * from "./Association.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833e9524",
  null
  
)

export default component.exports